import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import GratitudeCard from "../../../../components/dashboard/cards/gratitude-card/GratitudeCard";
import dayjs from "dayjs";
import ThemeModals from "../../../../components/common/modals/theme-modals/ThemeModals";
import AddGratitude from "./AddGratitude";
import {GratitudeService} from "../../../../services/gratitude-api.service";
import GratitudeViewSkeleton from "../../../skeletons/home/GratitudeViewSkeleton";
import {useNavigate} from "react-router-dom";
import NoRecord from "../../../../components/dashboard/no-record/NoRecord";
import {QuestionService} from "../../../../services/questions-api.service";
import JournalsModal from "../journals/JournalsModal";
import GratitudeIcon from "../../../../../assets/images/gradtitude-icon.png"
import JournalIcon from "../../../../../assets/images/journal-icon.png"

export default function GratitudeView() {
  const [addGratitude, setAddGratitude] = useState(false);
  const [addJournal, setAddJournal] = useState(false);
  const [gratitudeData, setGratitudeData] = useState([]);
  const [getListing, setGetListing] = useState(false);
  const [question, setQuestion] = useState([]);
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();

  async function GetQuestion(payload) {
    setLoader(true);
    const response = await QuestionService.getQuestion(payload);
    if (response?.data?.status) {
      setQuestion(response?.data?.data?.data[0]);
      setLoader(false);
    }
  }

  useEffect(() => {
    const payload = {
      category: "gratitude",
    };
    GetQuestion(payload);
  }, []);

  async function GetGratitudeData() {
    setLoader(true);
    const response = await GratitudeService.getGratitude();
    if (response?.data?.data?.status) {
      setGratitudeData(response.data?.data?.data?.result);
      setLoader(false);
    }
  }

  useEffect(() => {
    GetGratitudeData();
  }, [getListing]);

  if (loader) {
    return <GratitudeViewSkeleton />;
  }

  function GetGratitudeSelectedData(data) {}

  return (
    <div className={"gratitude"}>
      <div className={'gratitude-heading'}>
        <h2>
          My Gratitude{" "}

        </h2>
        <div className={'heading-area'}>
          <h3
              className={"cp journal-head "}
              onClick={() => {
                  setAddJournal(true);
              }}
          >
          {" "}
              {/*<JournalsHeadingIcon />*/}
              <img src={JournalIcon}/>
            Add Journals
        </h3>
          <h4
              className={"cp gratitude-head"}
              onClick={() => {
                setAddGratitude(true);
              }}
          >
          {" "}
              {/*<GratitudeHeadingIcon /> */}
            <img src={GratitudeIcon}/> Add Gratitude
          </h4>
        </div>
      </div>

      <Row>
        {gratitudeData.slice(0, 6).map((item, index) => {
          return (
            <Col className={"mb-4"} sm={12} md={6} xl={6} xxl={4} key={index}>
              <GratitudeCard
                getListing={getListing}
                setGetListing={setGetListing}
                heading={item.content[0].label}
                id={item._id}
                des={item.content[0].text}
                date={dayjs(item.createdAt).format("DD-MM-YYYY")}
              />
            </Col>
          );
        })}
        {gratitudeData.length <= 0 && <NoRecord />}
        {gratitudeData.length >= 6 && (
          <Col md={12}>
            <div className={"text-end"}>
              <span
                onClick={() => {
                  navigate("/gratitude");
                }}
                className={"see-all cp"}
              >
                See All
              </span>
            </div>
          </Col>
        )}
      </Row>

      <ThemeModals
        open={addGratitude}
        close={setAddGratitude}
        title={
          <div>
            {question?.multiQuestions?.map((item, index) => (
              <div key={index}>{item}</div>
            ))}
          </div>
        } // Each item in its own div
        content={
          <AddGratitude
            close={setAddGratitude}
            getListing={getListing}
            setGetListing={setGetListing}
          />
        }
      />

      <ThemeModals
          open={addJournal}
          close={setAddJournal}
          title={'Write Journals'} // Each item in its own div
          width={800}
          content={
            <JournalsModal
                close={setAddJournal}
                // getListing={getListing}
                // setGetListing={setGetListing}
            />
          }
      />
    </div>
  );
}
